export default {"src":"/_next/static/media/whiteArrow.3a7fc575.svg","height":12,"width":8};